import { useLocation } from 'react-router';

import { useQuery } from '@apollo/client';

import {
  GetWishlistByLoggedUserOrOwnerQuery,
  GetWishlistByLoggedUserOrOwnerQueryVariables,
} from '@notino/shared/definitions/types';

import getWishlistByLoggedUserOrOwnerQuery from './queries/wishlistByLoggedUserOrOwner.graphql';

const useOwner = (owner?: string): string | null => {
  const { search } = useLocation();

  if (owner) {
    return owner;
  }

  if (search) {
    return new URLSearchParams(search).get('id');
  }

  return null;
};

export const useWishlistForLoggedUserOrOwner = (owner?: string) => {
  const wishlistOwner = useOwner(owner);

  const { data: loggedUserOrOwner, loading } = useQuery<
    GetWishlistByLoggedUserOrOwnerQuery,
    GetWishlistByLoggedUserOrOwnerQueryVariables
  >(getWishlistByLoggedUserOrOwnerQuery, {
    ssr: true,
    variables: {
      owner: wishlistOwner,
    },
    errorPolicy: 'all',
  });
  return {
    productIds: loggedUserOrOwner?.WishlistByLoggedUserOrOwner?.products ?? [],
    loading,
    owner: wishlistOwner,
    userId: loggedUserOrOwner?.user?.id,
  };
};
